import { Box, Stack, HStack, InputGroup, InputLeftAddon, Select, AlertDialog, AlertDialogBody, 
        AlertDialogFooter, AlertDialogHeader, AlertDialogContent, AlertDialogOverlay, useDisclosure,
        useToast, Input, Textarea, Spacer, Button, Table, Thead, Tbody, Tr, Th, Td, TableContainer,
        Tooltip, Card, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton,
        ModalBody, Flex } from '@chakra-ui/react'
import { RepeatIcon } from '@chakra-ui/icons'
import { TYPES } from '../actions/cartAction'
import { useTable, usePagination } from "react-table"
import { DeleteIcon } from '@chakra-ui/icons'
import { useState, useReducer, useRef } from 'react'
import { cartInitialState, cartReducer } from '../reducers/cartReducer'
import { useForm } from 'react-hook-form'
import AlertPop from './AlertPop'
import { CircularProgress } from '@chakra-ui/react'
import useColumnsSaleAdd from "../hooks/useColumnsSaleAdd"
import { useNavigate } from "react-router-dom";
import authService from "../services/authService"
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from 'date-fns/locale/es';
registerLocale('es', es)
const moment = require('moment')

const SaleRecaulculatePrices = ({ idSale, isInvoice, voucherLetter, handleSubmitModal }) => {
    const [stateReducer, dispatch] = useReducer(cartReducer, cartInitialState)
    const { data } = stateReducer
    const { register, handleSubmit, formState: { errors }, reset, setValue, getValues } = useForm()
    const [saleDate, setSaleDate] = useState(new Date())
    const [grossPrice, setGrossPrice] = useState(parseFloat(0).toFixed(2))
    const [ivaPrice, setIvaPrice] = useState(parseFloat(0).toFixed(2))
    const [price, setPrice] = useState(parseFloat(0).toFixed(2))
    const { isOpen: isOpenSaleRecalculatePrices, onOpen: onOpenSaleRecalculatePrices, onClose: onCloseSaleRecalculatePrices } = useDisclosure()
    const { isOpen: isOpenConfirmSale, onOpen: onOpenConfirmSale, onClose: onCloseConfirmSale } = useDisclosure()
    const cancelRefConfirmSale = useRef()
    const toast = useToast()
    let [idCustomer, setIdCustomer] = useState(0)
    const initialRef = useRef(null)
    const [loading, setLoading] = useState(false)
    const [products, setProducts] = useState([])

    const navigate = useNavigate();

    const handleOpen = () => {
        if (isInvoice === true) {
            toast({
                title: "Este comprobante ya se encuentra facturado y no se pueden recalcular los precios",
                status: "error",
                duration: 3000,
                isClosable: true
            });
            return
        }

        if (voucherLetter === "Recibo" || voucherLetter === "N.C. No oficial") {
            toast({
                title: "Este comprobante no se puede recalcular ya que es un recibo o una nota de crédito",
                status: "error",
                duration: 3000,
                isClosable: true
            });
            return
        }

        const accessToken = localStorage.getItem("user")

        setLoading(true)

        dispatch({ type:TYPES.CLEAR_CART })

        fetch("https://api.sistemacorralonbianchi.com.ar/api/sale/" + idSale, {
            headers: {
                'Content-Type': 'application/json',
                "x-auth-token": accessToken
            }
        })
        .then(response => response.json())
        .then(data => {
            console.log(data._id)
            setIdCustomer(data.customer._id)
            setValue("_id", data._id)
            setValue("customer", data.customer.name)
            setValue("iva", data.customer.ivaName)
            setValue("cuit", data.customer.cuit)
            setValue("street", data.customer.street)
            setValue("city", data.customer.city)
            setValue("invoiceNumber", data.invoiceNumber)
            setValue("date", moment(data.date).add(3,"h").format('L'))
            setGrossPrice(parseFloat(data.grossPrice + data.ivaPrice).toFixed(2))
            setIvaPrice(parseFloat(0).toFixed(2))
            setPrice(parseFloat(data.price).toFixed(2))

            const arrProducts = data.products.map(product => {
                return {
                    _id: product._id,
                    id: product.id,
                    name: product.name,
                    quantity: parseFloat(product.quantity),
                    discount: parseFloat(product.discount),
                    warranty: product.warranty,
                    avgIva: parseFloat(product.avgIva),
                    unitPrice: parseFloat(product.unitPrice).toFixed(2),
                    totalPrice: parseFloat(product.totalPrice).toFixed(2)
                }
            })

            for (let i=0; i < arrProducts.length; i++) {
                initialCart(arrProducts[i])
            }

            setProducts(arrProducts)
            setLoading(false)
        })
        .catch(error => {
            authService.logout()
            navigate("/");
            window.location.reload();
        })

        setLoading(false)
        reset()
        clearCart()
        onOpenSaleRecalculatePrices()
    }

    const columns = useColumnsSaleAdd();

    const table = useTable({ columns, data, initialState: {pageSize: 30, pageIndex: 0, hiddenColumns: ["_id"]} }, usePagination );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        nextPage,
        previousPage,
        prepareRow,
        state
      } = table;

    const onSubmit = () => {
        onOpenConfirmSale()
    }

    const confirmSale = () => {
        const accessToken = localStorage.getItem("user")

        moment.locale("en")
        const products = []

        for (let i=0; i < data.length; i++) {
            products.push({
                _id: data[i]._id,
                serialNumber: data[i].serialNumber,
                quantity: parseFloat(data[i].quantity),
                discount: parseFloat(data[i].discount),
                warranty: data[i].warranty,
                avgIva: parseFloat(data[i].avgIva),
                unitPrice: parseFloat(data[i].unitPrice),
                totalPrice: parseFloat(data[i].totalPrice)
            })
        }

        const sale = {
            customer: idCustomer,
            _id: getValues("_id"),
            invoiceNumber: getValues("invoiceNumber"),
            invoiceLetter: "No oficial",
            date: moment(saleDate).format('L'),
            observations: getValues("observations") || "",
            grossPrice: parseFloat(grossPrice),
            ivaPrice: parseFloat(ivaPrice),
            price: parseFloat(price),
            products: products,
            cae: "",
            caeExpiration: moment(saleDate).format('L'),
            invoiceNumberAfip: "",
            dateAfip: moment(saleDate).format('L'),
            base64: "",
            isInvoice: false
        }
console.log(sale)
        fetch("https://api.sistemacorralonbianchi.com.ar/api/sale/recalculatePrices", {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                "x-auth-token": accessToken
            },
            body: JSON.stringify(sale)
        })
        .catch(error => {
            authService.logout()
            navigate("/");
            window.location.reload();
        })

        reset()
        clearCart()
        //setIsDisabled(true)
        onCloseConfirmSale()

        toast({
            title: "Los precios se modificaron correctamente",
            status: "success",
            duration: 3000,
            isClosable: true
        });

        handleSubmitModal()
        onCloseSaleRecalculatePrices()
    }

    const handleClose = () => {
        onCloseSaleRecalculatePrices()
    }

    const addToCart = (product, discount) => {
        let unitPrice
        let totalPrice
        if (parseFloat(discount) > 0) {
            const subtotal = parseFloat(product.price) - (parseFloat(product.price) * parseFloat(discount) / 100)
            unitPrice = parseFloat(subtotal).toFixed(2)
            totalPrice = parseFloat(product.quantity) * parseFloat(subtotal)
        } else {
            unitPrice = parseFloat(product.price).toFixed(2)
            totalPrice = parseFloat(product.quantity) * parseFloat(product.price)
        }
        
        product = {
            ...product,
            unitPrice: parseFloat(unitPrice).toFixed(2),
            totalPrice: parseFloat(totalPrice).toFixed(2)
        }
        
        dispatch({ type:TYPES.ADD_TO_CART, payload: product })
        calculatingPrices(product, true)
    }

    const clearCart = () => {
        dispatch({ type:TYPES.CLEAR_CART })

        setGrossPrice(parseFloat(0).toFixed(2))
        setIvaPrice(parseFloat(0).toFixed(2))
        setPrice(parseFloat(0).toFixed(2))

        onCloseSaleRecalculatePrices()
    }

    const calculatingPrices = (product, add) => {
        let sumGrossPrice = 0
        
        if (product) {
            for (let i=0; i < data.length; i++) {
                if (data[i].id === product.id) continue
                sumGrossPrice = parseFloat(sumGrossPrice) + parseFloat(data[i].totalPrice)
            }
            if (add === true) {
                const productSearch = data.find(obj => obj.id === product.id)
                if (productSearch) {
                    const quantityProduct = parseFloat(productSearch.quantity) + parseFloat(product.quantity)
                    const grossPriceProduct = parseFloat(quantityProduct) * parseFloat(product.unitPrice)
                    sumGrossPrice = parseFloat(sumGrossPrice) + parseFloat(grossPriceProduct)
                } else {
                    sumGrossPrice = parseFloat(sumGrossPrice) + parseFloat(product.totalPrice)
                }
            }
        }
        
        setGrossPrice(parseFloat(sumGrossPrice).toFixed(2))
        setIvaPrice(parseFloat(0).toFixed(2))
        setPrice(parseFloat(sumGrossPrice).toFixed(2))
    }

    const initialCart = (product) => {
        dispatch({ type:TYPES.ADD_TO_CART, payload: product })
    }

    const handleRecalculatePriceProduct = (idProduct, discount) => {
        const accessToken = localStorage.getItem("user")

        setLoading(true)

        fetch("https://api.sistemacorralonbianchi.com.ar/api/product/" + idProduct, {
            headers: {
                'Content-Type': 'application/json',
                "x-auth-token": accessToken
            }
        })
        .then(response => response.json())
        .then(data => {
            const product = {
                ...data,
                quantity: 0
            }
            addToCart(product, discount)
            setLoading(false)
        })
        .catch(error => {
            authService.logout()
            navigate("/");
            window.location.reload();
        })
    }

    const handleRecalculateAllPrices = async() => {
        setLoading(true)

        const accessToken = localStorage.getItem("user")

        const arrProducts = []

        for (let i=0; i < products.length; i++) {
            await fetch("https://api.sistemacorralonbianchi.com.ar/api/product/" + products[i]._id, {
                headers: {
                    'Content-Type': 'application/json',
                    "x-auth-token": accessToken
                }
            })
            .then(response => response.json())
            .then(data => {
                arrProducts.push({
                    ...data,
                    quantity: parseFloat(products[i].quantity),
                    discount: parseFloat(products[i].discount),
                })

                const product = {
                    ...data,
                    quantity: 0
                }
                
                addToCartV2(product, products[i].discount)
            })
            .catch(error => {
                authService.logout()
                navigate("/");
                window.location.reload();
            })
        }

        await calculatingPricesV2(arrProducts)
        setLoading(false)
    }

    const addToCartV2 = async (product, discount) => {
        let unitPrice
        let totalPrice
        if (parseFloat(discount) > 0) {
            const subtotal = parseFloat(product.price) - (parseFloat(product.price) * parseFloat(discount) / 100)
            unitPrice = parseFloat(subtotal).toFixed(2)
            totalPrice = parseFloat(product.quantity) * parseFloat(subtotal)
        } else {
            unitPrice = parseFloat(product.price).toFixed(2)
            totalPrice = parseFloat(product.quantity) * parseFloat(product.price)
        }
        
        product = {
            ...product,
            unitPrice: parseFloat(unitPrice).toFixed(2),
            totalPrice: parseFloat(totalPrice).toFixed(2)
        }
        
        dispatch({ type:TYPES.ADD_TO_CART, payload: product })
    }

    const calculatingPricesV2 = async(arrProducts) => {
        let sumGrossPrice = 0

        for (let i=0; i < arrProducts.length; i++) {
            const totalPrice = (parseFloat(arrProducts[i].quantity) * parseFloat(arrProducts[i].price)) - ((parseFloat(arrProducts[i].quantity) * parseFloat(arrProducts[i].price)) * parseFloat(arrProducts[i].discount) / 100)
            sumGrossPrice = parseFloat(sumGrossPrice) + parseFloat(totalPrice)
        }
        
        setGrossPrice(parseFloat(sumGrossPrice).toFixed(2))
        setIvaPrice(parseFloat(0).toFixed(2))
        setPrice(parseFloat(sumGrossPrice).toFixed(2))
    }

    return (
        <>
            <Tooltip label='Recalcular precios'><Button size="sm" colorScheme="yellow" onClick={handleOpen}><RepeatIcon/></Button></Tooltip>

            <Modal
                initialFocusRef={initialRef}
                isOpen={isOpenSaleRecalculatePrices}
                onClose={handleClose}
                size='6xl'
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Nueva venta</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>
                        {!loading && <form onSubmit={handleSubmit(onSubmit)} width='500px'>
                            <Stack spacing={4}>
                                <Card align="center" variant="elevated" padding="10px">
                                    <Stack spacing={4}>
                                        <HStack>
                                            <InputGroup>
                                                <InputLeftAddon children='Cliente' width={140} />
                                                <Input isDisabled {...register('customer', {required: 'Seleccione el cliente'})} />
                                                {/*<CustomerSearch handleSelect={handleSelect}/>*/}
                                            </InputGroup>

                                            <InputGroup>
                                                <InputLeftAddon children='Condición I.V.A.' width={140} />
                                                <Input isDisabled {...register('iva')} />
                                            </InputGroup>
                                        </HStack>
                                        {errors.customer && <AlertPop title={errors.customer.message} />}

                                        <HStack>
                                            <InputGroup>
                                                <InputLeftAddon children='C.U.I.T.' width={140} />
                                                <Input isDisabled {...register('cuit')} />
                                            </InputGroup>

                                            <InputGroup>
                                                <InputLeftAddon children='Dirección' width={140} />
                                                <Input isDisabled {...register('street')} />
                                            </InputGroup>

                                            <InputGroup>
                                                <InputLeftAddon children='Ciudad' width={140} />
                                                <Input isDisabled {...register('city')} />
                                            </InputGroup>
                                        </HStack>
                                    </Stack>
                                </Card>

                                <HStack>
                                    <InputGroup>
                                        <InputLeftAddon children='N° Comprobante' width={140} />
                                        <Input isDisabled {...register('invoiceNumber')} />
                                    </InputGroup>

                                    <InputGroup>
                                        <InputLeftAddon children='Fecha' width={140} />
                                        <Input isDisabled {...register('date')} />
                                    </InputGroup>

                                    <InputGroup>
                                        <InputLeftAddon children='Observaciones' width={140} />
                                        <Textarea size='sm' {...register('observations')} />
                                    </InputGroup>
                                </HStack>
                                {errors.invoiceLetter && <AlertPop title={errors.invoiceLetter.message} />}

                                <Spacer/>
                            </Stack>

                            <TableContainer paddingTop="15px">
                                <Table variant='striped' size="sm" colorScheme='blackAlpha' {...getTableProps()}>
                                    <Thead>
                                        {
                                            // Recorremos las columnas que previamente definimos
                                            headerGroups.map(headerGroup => (
                                                // Añadimos las propiedades al conjunto de columnas
                                                <Tr {...headerGroup.getHeaderGroupProps()}>
                                                {
                                                    // Recorremos cada columna del conjunto para acceder a su información
                                                    headerGroup.headers.map((column) => (
                                                    // Añadimos las propiedades a cada celda de la cabecera
                                                    <Th {...column.getHeaderProps()} >
                                                        {
                                                        // Pintamos el título de nuestra columna (propiedad "Header")
                                                        column.render("Header")
                                                        }
                                                    </Th>
                                                    ))
                                                }
                                                </Tr>
                                            ))
                                        }
                                    </Thead>
                                    <Tbody {...getTableBodyProps()}>
                                        {
                                            // Recorremos las filas
                                            page.map(row => {
                                                // Llamamos a la función que prepara la fila previo renderizado
                                                prepareRow(row);
                                                return (
                                                // Añadimos las propiedades a la fila
                                                <Tr {...row.getRowProps()}>
                                                    {
                                                    // Recorremos cada celda de la fila
                                                    row.cells.map((cell) => {
                                                        // Añadimos las propiedades a cada celda de la fila
                                                        return (
                                                        <Td {...cell.getCellProps()}>
                                                            {
                                                            // Pintamos el contenido de la celda
                                                            cell.render("Cell")
                                                            }
                                                        </Td>
                                                        );
                                                    })
                                                    }
                                                    <Td>
                                                        <Tooltip label='Recalcular precio'><Button size="sm" colorScheme="yellow" onClick={() => handleRecalculatePriceProduct(row.values._id, row.values.discount)}><RepeatIcon/></Button></Tooltip>
                                                    </Td>
                                                </Tr>
                                                );
                                            })
                                        }
                                    </Tbody>
                                </Table>
                            </TableContainer>

                            <Box paddingTop="10px" textAlign="center">
                                <Button marginRight="10px" colorScheme="facebook" onClick={() => previousPage()}>Anterior</Button>
                                <Button colorScheme="facebook" onClick={() => nextPage()}>Siguiente</Button>
                            </Box>

                            <Spacer/>

                            <Flex p={4}>
                                <Spacer/>
                                <Button colorScheme='yellow' mr={3} onClick={() => handleRecalculateAllPrices()}>Recalcular precios</Button>
                                
                                <InputGroup width={300} paddingLeft="10px">
                                    <InputLeftAddon children='Importe $' width={140} />
                                    <Input isDisabled placeholder='$' type='number' step='0.01' value={price} width={140} textAlign="right" />
                                </InputGroup>
                            </Flex>

                            <Flex p={4}>
                                <Spacer/>

                                <Button type='submit' colorScheme='blue' mr={3}>Guardar</Button>
                            </Flex>
                        </form>}

                        {loading && <Box paddingTop="15px" textAlign='center'> 
                            <CircularProgress isIndeterminate color='green.300' />
                        </Box>}
                    </ModalBody>
                </ModalContent>
            </Modal>

            <AlertDialog
                isOpen={isOpenConfirmSale}
                leastDestructiveRef={cancelRefConfirmSale}
                onClose={onCloseConfirmSale}
            >
                <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                        Confirmar modificación de precios
                    </AlertDialogHeader>

                    <AlertDialogBody>
                        ¿Desea confirmar la modificación de precios?
                    </AlertDialogBody>

                    <AlertDialogFooter>
                    <Button ref={cancelRefConfirmSale} onClick={onCloseConfirmSale}>
                        No
                    </Button>
                    <Button colorScheme='blue' onClick={confirmSale} ml={3}>
                        Confirmar
                    </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </>
    )
}

export default SaleRecaulculatePrices